{
  "blend": { "walkBelow": 5, "runAbove": 22 },
  "gaits": {
    "walk": {
      "duty": 0.6,
      "stride": 1.9,
      "armSwing": 0.42,
      "armBend": 0.5,
      "swing": [
        { "u": 0.25, "thigh": -0.15, "shin": -1.1 },
        { "u": 0.55, "thigh": 0.25, "shin": -0.85 },
        { "u": 0.8, "thigh": 0.6, "shin": -0.45 },
        { "u": 0.93, "thigh": 0.7, "shin": -0.15 }
      ]
    },
    "run": {
      "duty": 0.22,
      "stride": 6.6,
      "armSwing": 0.75,
      "armBend": 1.35,
      "swing": [
        { "u": 0.25, "thigh": -0.35, "shin": -1.45 },
        { "u": 0.55, "thigh": 0.35, "shin": -1.3 },
        { "u": 0.8, "thigh": 0.75, "shin": -0.55 },
        { "u": 0.93, "thigh": 0.85, "shin": -0.05 }
      ]
    }
  },
  "stand": {
    "legAngle": 0.25,
    "armAngle": 0.96,
    "armBend": 0.68
  }
}
